module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-shadow-15.a60d03b7.png";